// Auto-detect API base URL based on current hostname
// In production: uses same origin (e.g., https://aplicativointuitivo-precificacao.com)
// In preview: uses the env variable
function getApiBase() {
  const envUrl = process.env.REACT_APP_BACKEND_URL;
  const hostname = window.location.hostname;
  
  // If we're on the production domain, use same origin
  if (hostname !== 'localhost' && !hostname.includes('preview.emergentagent.com')) {
    return '';
  }
  
  // In preview/dev, use the env variable
  return envUrl || '';
}

export const API_BASE = getApiBase();
export const API = `${API_BASE}/api`;
